import { useEffect, useRef } from "react";

import ProviderSearchModal from "./components/Modal/ProviderSearchModal";
import ProviderSearchContainer from "./components/ProviderSearchContainer";
import { useProviderSearchStore } from "./store/providerSearchStore";

export default function ProviderSearch({
  isModal,
  openModal,
  setCloseModal,
  caseInfo,
  handleOnClickCreateCustomProvider,
  handleOnClickAddProvider,
}) {
  const { setHandleOnClickCreateCustomProvider, setHandleOnClickAddProvider, setCaseId } =
    useProviderSearchStore();

  const caseId = caseInfo?.id ?? caseInfo?.pk;
  const handleOnClickCreateCustomProviderRef = useRef(handleOnClickCreateCustomProvider);
  const handleOnClickAddProviderRef = useRef(handleOnClickAddProvider);

  useEffect(() => {
    handleOnClickCreateCustomProviderRef.current = handleOnClickCreateCustomProvider;
    handleOnClickAddProviderRef.current = handleOnClickAddProvider;
  }, [handleOnClickAddProvider, handleOnClickCreateCustomProvider]);

  useEffect(() => {
    setCaseId(caseId || null);
    if (caseId) {
      setHandleOnClickCreateCustomProvider(handleOnClickCreateCustomProviderRef.current);
      setHandleOnClickAddProvider(handleOnClickAddProviderRef.current);
    }
  }, [
    caseId,
    openModal,
    setCaseId,
    setHandleOnClickAddProvider,
    setHandleOnClickCreateCustomProvider,
  ]);

  return (
    <>
      {isModal ? (
        <ProviderSearchModal openModal={openModal} setCloseModal={setCloseModal} />
      ) : (
        <ProviderSearchContainer />
      )}
    </>
  );
}
